interface BookingProgressProps {
  currentStep: number;
  completedSteps: number[];
  onStepClick: (step: number) => void;
}

const STEPS = [
  { n: 1, label: "Service", icon: "ri-customer-service-2-line" },
  { n: 2, label: "Select Product", icon: "ri-list-check-2" },
  { n: 3, label: "Your Booking", icon: "ri-calendar-check-line" },
];

export default function BookingProgress({ currentStep, completedSteps, onStepClick }: BookingProgressProps) {
  return (
    <div className="w-full">
      <div className="hidden md:flex items-center justify-center gap-0">
        {STEPS.map((step, idx) => {
          const isCompleted = completedSteps.includes(step.n);
          const isCurrent = currentStep === step.n;
          const isClickable = isCompleted;

          return (
            <div key={step.n} className="flex items-center">
              <button
                onClick={() => isClickable && onStepClick(step.n)}
                disabled={!isClickable}
                className={`flex flex-col items-center gap-1.5 group transition-all ${isClickable ? "cursor-pointer" : "cursor-default"}`}
              >
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full border-2 font-black text-sm transition-all
                    ${isCurrent ? "bg-cl-dark border-cl-dark text-white scale-110" : ""}
                    ${isCompleted ? "bg-cl-green border-cl-green text-white" : ""}
                    ${!isCurrent && !isCompleted ? "bg-white border-transparent text-gray-400" : ""}
                  `}
                >
                  {isCompleted ? (
                    <i className="ri-check-line text-sm font-black"></i>
                  ) : (
                    <i className={`${step.icon} text-sm`}></i>
                  )}
                </div>
                <span
                  className={`text-xs font-bold whitespace-nowrap transition-colors
                    ${isCurrent ? "text-cl-dark" : ""}
                    ${isCompleted ? "text-cl-green" : ""}
                    ${!isCurrent && !isCompleted ? "text-gray-400" : ""}
                  `}
                >
                  {step.label}
                </span>
              </button>

              {idx < STEPS.length - 1 && (
                <div className={`w-16 lg:w-24 h-0.5 mx-2 mb-5 transition-colors ${isCompleted ? "bg-cl-green" : "bg-gray-200"}`}></div>
              )}
            </div>
          );
        })}
      </div>

      <div className="md:hidden flex items-center justify-between px-1">
        <span className="text-xs font-bold text-cl-dark/60">Step {currentStep} of {STEPS.length}</span>
        <span className="text-sm font-black text-cl-dark">{STEPS[currentStep - 1].label}</span>
        <div className="flex gap-1">
          {STEPS.map((s) => (
            <div
              key={s.n}
              className={`h-1.5 rounded-full transition-all ${
                s.n < currentStep ? "w-5 bg-cl-green" :
                s.n === currentStep ? "w-8 bg-cl-dark" : "w-5 bg-gray-200"
              }`}
            ></div>
          ))}
        </div>
      </div>

      <div className="md:hidden mt-3 h-1 bg-gray-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-cl-green rounded-full transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (STEPS.length - 1)) * 100}%` }}
        ></div>
      </div>
    </div>
  );
}
